<div
  class="cad-canvas-host"
  #host
  tabindex="0"
  [class.cad-canvas-host--light]="background === 'light'"
  [class.cad-canvas-host--fullscreen]="isFullscreen"
>
  <div class="cad-viewport" #viewport></div>

  <div class="cad-toolbar" *ngIf="state === 'ready'">
    <button type="button" class="cad-tool" (click)="fitView()" title="Fit drawing to view">
      <i class="bi bi-bounding-box"></i>
    </button>
    <button
      type="button"
      class="cad-tool"
      [class.cad-tool--active]="layersOpen"
      (click)="layersOpen = !layersOpen"
      [disabled]="!layers.length"
      title="Layers"
    >
      <i class="bi bi-layers"></i>
    </button>
    <button type="button" class="cad-tool" (click)="toggleBackground()" [title]="background === 'dark' ? 'Light background' : 'Dark background'">
      <i class="bi" [ngClass]="background === 'dark' ? 'bi-sun' : 'bi-moon'"></i>
    </button>
    <button
      type="button"
      class="cad-tool"
      *ngIf="fullscreenSupported"
      [class.cad-tool--active]="isFullscreen"
      (click)="toggleFullscreen()"
      [title]="isFullscreen ? 'Exit full screen (Esc)' : 'Full screen (F)'"
    >
      <i class="bi" [ngClass]="isFullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'"></i>
    </button>
  </div>

  <div class="cad-fs-bar" *ngIf="isFullscreen">
    <span class="cad-fs-bar__name" *ngIf="drawing" [title]="drawing.original_name">
      <i class="bi bi-file-earmark-ruled"></i>
      {{ drawing.original_name }}
    </span>
    <button type="button" class="cad-tool" (click)="toggleFullscreen()" title="Exit full screen (Esc)">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="cad-layers" *ngIf="state === 'ready' && layersOpen">
    <div class="cad-layers__head">
      <span>Layers ({{ layers.length }})</span>
      <span class="cad-layers__bulk">
        <button type="button" (click)="setAllLayers(true)">All</button>
        <button type="button" (click)="setAllLayers(false)">None</button>
      </span>
    </div>
    <ul>
      <li *ngFor="let layer of layers">
        <label>
          <input type="checkbox" [checked]="layer.visible" (change)="toggleLayer(layer)" />
          <span class="cad-layers__swatch" [style.background]="layer.color"></span>
          <span class="cad-layers__name" [title]="layer.displayName">{{ layer.displayName }}</span>
        </label>
      </li>
    </ul>
  </div>

  <div class="cad-canvas-overlay" *ngIf="state === 'loading'">
    <div class="cad-spinner" aria-hidden="true"></div>
    <span>{{ progressLabel }}<ng-container *ngIf="progressPct !== null"> · {{ progressPct }}%</ng-container></span>
  </div>

  <div class="cad-canvas-overlay cad-canvas-overlay--notice" *ngIf="state === 'unavailable' || state === 'error'" role="alert">
    <i class="bi" [ngClass]="state === 'unavailable' ? 'bi-tools' : 'bi-exclamation-triangle'"></i>
    <p>{{ message }}</p>
    <div class="cad-canvas-overlay__actions">
      <button type="button" class="cad-retry" (click)="retry()">Try again</button>
      <button type="button" class="cad-retry" *ngIf="drawing && downloadHandler" (click)="downloadHandler()">Download original</button>
      <a class="cad-retry" *ngIf="drawing && !downloadHandler && drawing.file_url" [href]="drawing.file_url" target="_blank" rel="noopener" download>Download original</a>
    </div>
  </div>

  <div class="cad-canvas-overlay cad-canvas-overlay--empty" *ngIf="state === 'idle'">
    <i class="bi bi-file-earmark-ruled"></i>
    <p>Select or upload a DWG/DXF drawing to view it here.</p>
  </div>
</div>
